var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('div',[_c('MonthSelector',{on:{"select":_vm.load}})],1),_c('List'),_c('SalesForce')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }